// Only public content routes use trailing slashes. Operational endpoints stay untouched.
export function canonicalLink(value) {
 if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return value;
 const match=value.match(/^([^?#]*)([?#].*)?$/), path=match[1], suffix=match[2]||'';
 const clean=path.replace(/\/+$/,'')||'/';
 if(['/all-news','/category/all-news'].includes(clean))return '/news'+suffix;
 if(/^\/story\/[^/]+$/.test(clean))return '/'+clean.split('/')[2]+'/'+suffix;
 const fixed=new Set(['news','search','about-us','contact-us','corrections-feedback','privacy-policy','terms-of-use','your-privacy-choices','advertise-with-us','health']);
 if(/^\/(category|author)\/[^/]+$/.test(clean) || (/^\/[^/.]+$/.test(clean)&&!fixed.has(clean.slice(1))&&!/^\/(api|wp-json|wp-admin|cdn-cgi)$/.test(clean)))return clean+'/'+suffix;
 return value;
}
